import { setHostAdapter } from "@cinesys/experience-ui/host";
import { customerAppsHostAdapter } from "./customerAppsHostAdapter";

/**
 * Runs `setHostAdapter` at import time, not inside any function. Every screen in this app is a
 * plain static import now (see `AppRouter.tsx`'s own doc comment) — some of them (e.g.
 * `CollectionsBrowserScreen.tsx`) call `getHostAdapter()`-backed helpers like `getModal()` at
 * their OWN module scope, so this has to have already run before ANY of `App`'s module graph
 * gets evaluated, not just before it mounts.
 *
 * ES module evaluation runs a file's own imports, in declared order, before any of that file's
 * own top-level code — `index.tsx` relies on that by importing this file before `./App`, which
 * guarantees this call finishes before `App` (and everything it transitively imports) evaluates.
 */
setHostAdapter(customerAppsHostAdapter);
